module.exports = __webpack_public_path__ + "static/media/alert.13009484.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/alert.png
// module id = 1869
// module chunks = 6